// ------------ userInventory ------------ //

export const objectEmpty = { type: "empty" };
export const orderEquipment = ["ship", "helmet", "wings", "weapon", "armor", "shield", "gloves", "pants", "boots"];

// ------------ Zone ------------ //

export const zoneMap = [
  { name: "forest", rLvlMin: "1", rLvlMax: "45" },
  { name: "caves", rLvlMin: "46", rLvlMax: "90" },
  { name: "desert", rLvlMin: "91", rLvlMax: "135" },
  { name: "sea", rLvlMin: "136", rLvlMax: "180" },
  { name: "mountain", rLvlMin: "181", rLvlMax: "225" },
  { name: "hell", rLvlMin: "226", rLvlMax: "300" },
];

// ------------ userCard ------------ //
export const titleColor = {
  iron: "#8F8E8F",
  bronze: "#CD7F32",
  silver: "#C0C0C0",
  gold: "#FFD700",
  platinum: "#87CEEB",
  diamond: "#B9F2FF",
  challenger: "#FF69B4",
};
